import { css } from "@emotion/css";
import { ExclamationCircleIcon } from "@octopusdeploy/design-system-icons";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
export interface InputErrorProps {
    /**
     * Error message to display.
     */
    error?: string;
    /**
     * The ID of the error element.
     * This is important for accessiblity and ensures that the input is correctly associated with the error.
     */
    id: string;
}
/**
 *
 * InputError renders error messages for form fields, displaying validation errors
 * with an accompanying danger icon.
 *
 * @internal
 */
export function InputError({ error, id }: InputErrorProps) {
    if (!error) {
        return null;
    }
    return (<p className={errorStyles} id={id}>
            <ExclamationCircleIcon size={20} ariaLabel="Error" color={themeTokens.color.icon.danger}/>
            <span>{error}</span>
        </p>);
}
const errorStyles = css({
    display: "grid",
    margin: 0,
    gridTemplateColumns: "auto 1fr",
    alignItems: "start",
    gap: space[4],
    color: themeTokens.color.text.danger,
    font: text.body.regular.large,
    lineHeight: 1.25, // Note: Design tweak - line-height looked awkward on narrow inputs
    textWrap: "pretty",
    // Align icon with form inputs
    transform: `translateX(-${space[1]})`,
});
